import { render, staticRenderFns } from "./Authorizations.html?vue&type=template&id=a3280712&external"
import script from "./Authorizations.ts?vue&type=script&lang=ts&external"
export * from "./Authorizations.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports